var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visibility && _vm.config.src)?_c('img',{staticClass:"img-fluid",class:_vm.config.fixed ? 'position-fixed' : 'position-absolute',style:({..._vm.transform, ..._vm.size, ..._vm.opacity, ..._vm.zIndex}),attrs:{"src":_vm.config.src,"alt":"float image"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }